import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectDefaulAsyncComponent } from './select-defaul-async.component';
import { DirectivasModule } from '@directives/directivas.module';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [
    SelectDefaulAsyncComponent,
  ],
  exports: [
    SelectDefaulAsyncComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    DirectivasModule
  ],
})
export class SelectDefaulAsyncModule {}
